var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"w-full driver-graph overflow-x-auto overflow-y-hidden",domProps:{"innerHTML":_vm._s(_vm.data)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }